import PropTypes from "prop-types";
import NotifcationCard from "../../Components/NavigationCard/NotificationCard";
export default function NotificationList({ notificaitonList }) {
  const notificationHandler = () => {};

  return (
    <div>
      {notificaitonList.map((currVal, index) => (
        <NotifcationCard
          key={index}
          image={currVal.Image}
          title={currVal.Title}
          description={currVal.Description}
          body={currVal.Body}
          type={currVal.Type}
          handleNotification={notificationHandler}
        />
      ))}
    </div>
  );
}

NotificationList.propTypes = {
  notificaitonList: PropTypes.object,
};
